////import { Logger } from "aws-amplify"
////const logger = new Logger("$store/presence/getters") 

export default {
  vehiclesMap: state => {
    return new Map(state.vehicles.map(({ id, vehicle_name }) => [id, vehicle_name]))
  },

  vehiclesSet: state => {
    return state.vehicles.reduce((set, item) => {
      set[item.id] = item
      return set
    }, {})
  },
  
  findVehicle: state => id => {
    return state.vehicles.find(vehi => vehi.id === id);
  },

  findVehicleById: state => id => {
    return state.vehicles.find(vehi => {
      if (vehi.devices && vehi.devices.length > 0) {
        return vehi.devices.some(dev => dev.device_id === id);
      }
      return false;
    });
  }
}